"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _eventEmitter = _interopRequireDefault(require("./eventEmitter"));

var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));

var _result = _interopRequireDefault(require("lodash/result"));

var _defaults2 = _interopRequireDefault(require("lodash/defaults"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _omit2 = _interopRequireDefault(require("lodash/omit"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// Backbone.Model
var _default =
/*#__PURE__*/
function (_EventEmitter) {
  (0, _inherits2["default"])(_default, _EventEmitter);

  // Backbone **Models** are the basic data object in the framework --
  // frequently representing a row in a table in a database on your server.
  // A discrete chunk of data and a bunch of useful, related methods for
  // performing computations and transformations on that data.
  // Create a new model with the specified attributes. A client id (`cid`)
  // is automatically generated and assigned for you.
  function _default() {
    var _this;

    var attributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck2["default"])(this, _default);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(_default).call(this));
    var defaults,
        attrs = attributes,
        proto = Object.getPrototypeOf((0, _assertThisInitialized2["default"])(_this)),
        ctr = proto.constructor; // copy idAttribute to prototype as in Backbone.Model

    proto.idAttribute = ctr.idAttribute || 'id';
    _this.cid = (0, _uniqueId["default"])('c');
    _this.attributes = {}; // A list of options to be attached directly to the model, if provided.
    // Object.assign(this, pick(options, ['url', 'urlRoot', 'collection']));

    if (options.url) {
      _this.url = options.url;
    }

    if (options.urlRoot) {
      _this.urlRoot = options.urlRoot;
    }

    if (options.collection) {
      _this.collection = options.collection;
    }

    if (options.parse) attrs = _this.parse(attrs, options) || {};

    if (defaults = (0, _result["default"])((0, _assertThisInitialized2["default"])(_this), 'defaults')) {
      attrs = (0, _defaults2["default"])({}, attrs, defaults);
    }

    _this.set(attrs, options); // A hash of attributes whose current and previous value differ.


    _this.changed = {}; // The value returned during the last failed validation.

    _this.validationError = null;

    _this.initialize.call((0, _assertThisInitialized2["default"])(_this), attributes, options);

    return _this;
  } // Initialize is an empty function by default. Override it with your own
  // initialization logic.


  (0, _createClass2["default"])(_default, [{
    key: "initialize",
    value: function initialize() {} // Return a copy of the model's `attributes` object.

  }, {
    key: "toJSON",
    value: function toJSON(options) {
      return _objectSpread({}, this.attributes);
    } // Proxy `Backbone.sync` by default -- but override this if you need
    // custom syncing semantics for *this* particular model.

  }, {
    key: "sync",
    value: function sync() {} // Get the value of an attribute.

  }, {
    key: "get",
    value: function get(attr) {
      return this.attributes[attr];
    } // Get the HTML-escaped value of an attribute.

  }, {
    key: "escape",
    value: function escape(attr) {
      window.console.warn('escape is deprecated');
      return this.get(attr);
    } // Returns `true` if the attribute contains a value that is not null
    // or undefined.

  }, {
    key: "has",
    value: function has(attr) {
      var value = this.get(attr);
      return value !== null && value !== undefined && value !== '';
    } // Set a hash of model attributes on the object, firing `"change"`. This is
    // the core primitive operation of a model, updating the data and notifying
    // anyone who needs to know about the change in state. The heart of the beast.

  }, {
    key: "set",
    value: function set(key, val, options) {
      var attr, attrs, unset, changes, silent, changing, prev, current;
      if (key === null) return this; // Handle both `"key", value` and `{key: value}` -style arguments.

      if ((0, _typeof2["default"])(key) === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      } // Run validation.


      if (!this._validate(attrs, options)) return false; // Extract attributes and options.

      unset = options.unset;
      silent = options.silent;
      changes = [];
      changing = this._changing;
      this._changing = true;

      if (!changing) {
        this._previousAttributes = _objectSpread({}, this.attributes);
        this.changed = {};
      }

      current = this.attributes;
      prev = this._previousAttributes; // Check for changes of `id`.

      if (this.idAttribute in attrs) this.id = attrs[this.idAttribute]; // For each `set` attribute, update or delete the current value.

      for (attr in attrs) {
        if (attrs.hasOwnProperty(attr)) {
          val = attrs[attr];
          if (!(0, _isEqual["default"])(current[attr], val)) changes.push(attr);

          if (!(0, _isEqual["default"])(prev[attr], val)) {
            this.changed[attr] = val;
          } else {
            delete this.changed[attr];
          }

          unset ? delete current[attr] : current[attr] = val;
        }
      } // Trigger all relevant attribute changes.


      if (!silent) {
        if (changes.length) this._pending = true;
        var i = 0,
            l = changes.length;

        for (i; i < l; i++) {
          this.trigger('change:' + changes[i], this, current[changes[i]], options);
        }
      } // You might be wondering why there's a `while` loop here. Changes can
      // be recursively nested within `"change"` events.


      if (changing) return this;

      if (!silent) {
        while (this._pending) {
          this._pending = false;
          this.trigger('change', this, options);
        }
      }

      this._pending = false;
      this._changing = false;
      return this;
    } // Remove an attribute from the model, firing `"change"`. `unset` is a noop
    // if the attribute doesn't exist.

  }, {
    key: "unset",
    value: function unset(attr, options) {
      return this.set(attr, void 0, _objectSpread({}, options, {
        unset: true
      }));
    } // Clear all attributes on the model, firing `"change"`.

  }, {
    key: "clear",
    value: function clear() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var attrs = {},
          key;

      for (key in this.attributes) {
        if (this.attributes.hasOwnProperty(key)) {
          attrs[key] = void 0;
        }
      }

      return this.set(attrs, _objectSpread({}, options, {
        unset: true
      }));
    } // Determine if the model has changed since the last `"change"` event.
    // If you specify an attribute name, determine if that attribute has changed.

  }, {
    key: "hasChanged",
    value: function hasChanged(attr) {
      if (attr === null) return !(0, _isEmpty["default"])(this.changed);

      if (this.changed) {
        return this.changed.hasOwnProperty(attr);
      } else {
        return false;
      }
    } // Return an object containing all the attributes that have changed, or
    // false if there are no changed attributes. Useful for determining what
    // parts of a view need to be updated and/or what attributes need to be
    // persisted to the server. Unset attributes will be set to undefined.
    // You can also pass an attributes object to diff against the model,
    // determining if there *would be* a change.

  }, {
    key: "changedAttributes",
    value: function changedAttributes(diff) {
      if (!diff) return this.hasChanged() ? _objectSpread({}, this.changed) : false;
      var val,
          changed = false,
          old = this._changing ? this._previousAttributes : this.attributes,
          attr;

      for (attr in diff) {
        if (diff.hasOwnProperty(attr)) {
          if ((0, _isEqual["default"])(old[attr], val = diff[attr])) continue;
          (changed || (changed = {}))[attr] = val;
        }
      }

      return changed;
    } // Get the previous value of an attribute, recorded at the time the last
    // `"change"` event was fired.

  }, {
    key: "previous",
    value: function previous(attr) {
      if (attr === null || !this._previousAttributes) return null;
      return this._previousAttributes[attr];
    } // Get all of the attributes of the model at the time of the previous
    // `"change"` event.

  }, {
    key: "previousAttributes",
    value: function previousAttributes() {
      return _objectSpread({}, this._previousAttributes);
    } // Fetch the model from the server. If the server's representation of the
    // model differs from its current attributes, they will be overridden,
    // triggering a `"change"` event.

  }, {
    key: "fetch",
    value: function fetch(options) {
      options = options ? _objectSpread({}, options) : {};
      if (options.parse === void 0) options.parse = true;
      var model = this,
          success = options.success;

      options.success = function (resp) {
        if (!model.set(model.parse(resp, options), options)) return false;
        if (success) success(model, resp, options);
        model.trigger('sync', model, resp, options);
      };

      this._wrapError(this, options);

      return this.sync('read', this, options);
    } // Set a hash of model attributes, and sync the model to the server.
    // If the server returns an attributes hash that differs, the model's
    // state will be `set` again.

  }, {
    key: "save",
    value: function save(key, val, options) {
      var attrs,
          method,
          xhr,
          attributes = this.attributes; // Handle both `"key", value` and `{key: value}` -style arguments.

      if (key === null || (0, _typeof2["default"])(key) === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      } // If we're not waiting and attributes exist, save acts as `set(attr).save(null, opts)`.


      if (attrs && (!options || !options.wait) && !this.set(attrs, options)) return false;
      options = _objectSpread({
        validate: true
      }, options); // Do not persist invalid models.

      if (!this._validate(attrs, options)) return false; // Set temporary attributes if `{wait: true}`.

      if (attrs && options.wait) {
        this.attributes = _objectSpread({}, attributes, {}, attrs);
      } // After a successful server-side save, the client is (optionally)
      // updated with the server-side state.


      if (options.parse === void 0) options.parse = true;
      var model = this,
          success = options.success;

      options.success = function (resp) {
        // Ensure attributes are restored during synchronous saves.
        model.attributes = attributes;
        var serverAttrs = model.parse(resp, options);
        if (options.wait) serverAttrs = _objectSpread({}, attrs || {}, {}, serverAttrs);

        if ((0, _typeof2["default"])(serverAttrs) === 'object' && !Array.isArray(serverAttrs) && !model.set(serverAttrs, options)) {
          return false;
        }

        if (success) success(model, resp, options);
        model.trigger('sync', model, resp, options);
      };

      this._wrapError(this, options);

      method = this.isNew() ? 'create' : options.patch ? 'patch' : 'update';
      if (method === 'patch') options.attrs = attrs;
      xhr = this.sync(method, this, options); // Restore attributes.

      if (attrs && options.wait) this.attributes = attributes;
      return xhr;
    } // Destroy this model on the server if it was already persisted.
    // Optimistically removes the model from its collection, if it has one.
    // If `wait: true` is passed, waits for the server to respond before removal.

  }, {
    key: "destroy",
    value: function destroy(options) {
      options = options ? _objectSpread({}, options) : {};
      var model = this,
          success = options.success;

      var destroy = function destroy() {
        model.trigger('destroy', model, model.collection, options);
      };

      options.success = function (resp) {
        if (options.wait || model.isNew()) destroy();
        if (success) success(model, resp, options);
        if (!model.isNew()) model.trigger('sync', model, resp, options);
      };

      if (this.isNew()) {
        options.success();
        return false;
      }

      this._wrapError(this, options);

      var xhr = this.sync('delete', this, options);
      if (!options.wait) destroy();
      return xhr;
    } // Default URL for the model's representation on the server -- if you're
    // using Backbone's restful methods, override this to change the endpoint
    // that will be called.

  }, {
    key: "url",
    value: function url() {
      var base = (0, _result["default"])(this, 'urlRoot') || (0, _result["default"])(this.collection, 'url') || this._urlError();

      if (this.isNew()) return base;
      return base + (base.charAt(base.length - 1) === '/' ? '' : '/') + encodeURIComponent(this.id);
    } // **parse** converts a response into the hash of attributes to be `set` on
    // the model. The default implementation is just to pass the response along.

  }, {
    key: "parse",
    value: function parse(resp, options) {
      return resp;
    } // Create a new model with identical attributes to this one.

  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor(this.attributes);
    } // A model is new if it has never been saved to the server, and lacks an id.

  }, {
    key: "isNew",
    value: function isNew() {
      return this.id === null;
    } // Check if the model is currently in a valid state.

  }, {
    key: "isValid",
    value: function isValid() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this._validate({}, _objectSpread({}, options, {
        validate: true
      }));
    }
  }, {
    key: "keys",
    value: function keys() {
      return Object.keys(this.attributes || {});
    }
  }, {
    key: "values",
    value: function values() {
      return Object.values(this.attributes);
    }
  }, {
    key: "pairs",
    value: function pairs() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return Object.entries(_objectSpread({}, this.attributes, {}, args));
    }
  }, {
    key: "invert",
    value: function invert() {
      window.console.warn('invert is deprecated');
      return this.attributes;
    }
  }, {
    key: "pick",
    value: function pick() {
      window.console.warn('pick is deprecated');
      return this.attributes;
    }
  }, {
    key: "omit",
    value: function omit() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _omit2["default"].apply(void 0, [this.attributes].concat(args));
    } // Run validation against the next complete set of model attributes,
    // returning `true` if all is well. Otherwise, fire an `"invalid"` event.

  }, {
    key: "_validate",
    value: function _validate(attrs) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!options.validate || !this.validate) return true;
      attrs = _objectSpread({}, this.attributes, {}, attrs);
      var error = this.validationError = this.validate(attrs, options) || null;
      if (!error) return true;
      this.trigger('invalid', this, error, _objectSpread({}, options, {
        validationError: error
      }));
      return false;
    }
  }, {
    key: "_wrapError",
    value: function _wrapError(model, options) {
      var error = options.error;

      options.error = function (resp) {
        if (error) error(model, resp, options);
        model.trigger('error', model, resp, options);
      };
    }
  }, {
    key: "_urlError",
    value: function _urlError() {
      throw new Error('A "url" property or function must be specified');
    }
  }]);
  return _default;
}(_eventEmitter["default"]);

exports["default"] = _default;